import { useQuery } from "react-query";
import { queryGet } from "@pocapan/shared/utils/queryClient";
import type { ArtistListType } from '../../types/ArtistType';
import { QUERY_KEYS } from '../constants/queryKeys';

/**
 * 내가 팔로우한 아티스트 목록 조회 쿼리
 */
const useMyFamDomsQuery = () => {
  const { data, isLoading, isError } = useQuery<ArtistListType>(
    [QUERY_KEYS.MY_FANDOMS],
    () => queryGet('/api/v1/artists?liked_only=true'),
    {
      select: (data: any) => data.artists
    }
  );
  return { data, isLoading, isError };
};
export default useMyFamDomsQuery;